var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDPerak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 750",
    preserveAspectRatio: "xMidYMid slice",
    id: "svgN",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N1",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M615.4 159.1l4.1-6.1-.3-2.6 3.2-3.5 4.6 6.4s3.8 4.3 8.1 1.7c4.3-2.6 6.4-7 6.4-7l-4.1-7.8 9.8 1.4s15.9-3.2 20.9-.6l-.3-7 1.4-2 2.6.6.6-3.8-5.6-9.5-1.2 1.2c-.5.6-3.6 1.8-4 2l-1.6.5c-2.5.4-5.3-.2-6.1 2.3-1.5 4.7-12.1 13.2-12.3 4.6-.1-4.2-2.2-8.4-3.5-12.8-.7-2.4-2.4-2-2.6-4-.1-1.1-2.5-2.7-2.5-2.7l-.7-3.2-4.5-2.4-.8-3.4c-1 .2-3.1-2.2-3.1-2.2-1.7-.1-2.8-1.2-3.5-3.1-1.2-3.5-4.7 1.8-6.8.2-1.8-1.4-3.2-6.9-5.4-8.4-2.9-2-5.3-3.2-7.7-5.7 0 0-.1 3.4-6.8 3.4-1.2 0-5.6.3-6.8 1.8-1.7 2.1.8 6.5 4.1 7.2-1.4-.4-.2 1.8-1.5 1.5 1.1.7 1.1 2.8 2.3 2.8 2.1.1 3.9 1.1 4.4 3.3.6 2.8 1.1 5.7-1.8 6.9.9 1.1.2 2.9 1.5 3.8-3.1 2.8-2.1 8.5-5.3 11.4-.9.8-3.6-1.1-4.8-.5-2.5 1.2 1.2 3.4.8 5-.7 2.5-2.6 3.3-6.1 3.4.6 3.2-3.4 1.2 4.3 9.1 2.7 2.8.5 3.4-2.1 5.2.5.5 0 2.8 0 3.7.1 1.5 2.3 1 2.6 2.5.3 2-.1 3-1.3 4.7l-.8 1-.1.1c-.7 1-1 2.8-1.6 4.3l.3.4.6 2.9 5.5.6 5.8 1.7 2-1.7 4.1-1.7 3.5 3.2 1.4-.9 5.5-.4 1.7-10.4 3.5 2.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "N3",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M689.5 266.2l-4.8-4.2-6.7-17.7-2.6-3.8v-6.7l1.2-1.7v-3.8c4.6-3.5-2.6-6.4-2.6-6.4l2.3-2.9c5.5-7.2-1.7-8.7-1.7-8.7l-3.5-2.3c1.2-3.8 6.1-7 6.1-7l-3.5-5.8 3.5-1.7 2-2.9-3.8-2-6.7 3.2.3 2.9-2.3.9-4.3-2.6-3.5-.9-4.1 1.2-.3-7-4.3.9-3.2 4.6-5.8-1.2-7.2-2.3-2.3-4.6-2.9-4.6-3.8-3.2-11.6-9.3-8.7.6-1.4.9-3.5-3.2-4.1 1.7-2 1.7-5.8-1.7-5.5-.6-.6-2.9-.3-.4-.8 1.8-1.4 2.6s-1.2 2.2-1.9 2.5c-.6.3-.5-.2-3 .2-2.5.3-1.4.8-3.1-.5-1.7-1.2-3.3-1.2-3.7-.8-.5.5-.9 1.6-1.2 2.2-.3.6.2 1.9.2 1.9l-1.1.8-3.7 5.3 1.8 1.1c-1.7 2.6 0 6.1-.7 9.4l-.1.4 4.9 3.9 4.6-1.4 2.6 2 3.2 11.6 3.5 8.7-2.3 1.4 2.9 10.4s10.1 9.3 2.6 17.1c0 0-6.4 1.2-7.5 5.5l-1.2 2.6-2 .6-4.1 3.2 5.2 7 5.8 6.4v3.5l-.2.3 8.9 2 1.4-.9 5.2 4.1 4.9-2.6 6.4 5.8c5.5-.9 4.9 3.2 4.9 3.2l18.5 8.7-.1 3.8 1.6 1.4 3.5-2.3 5.2 3.2 5.2.9 12.5-11.9.9 3.2 2.9.3c2.9-1.7 7.8-15.1 7.8-15.1 17.4 4.3 20.9-8.1 20.9-8.1l-1.9-1.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "N4",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M612.5 283.7s.6-4.1-4.9-3.2l-6.4-5.8-4.9 2.6-5.2-4.1-1.4.9-8.9-2-1.8 2.3-1.2 4.1 1.7 4.9s-3.2 15.1-9 17.4h-2s-4.3 7.2.3 11.6l.6 2.9-4.9 2.3-.6 3.5-1.4.9 1.2 5.5v.3l6.4-3.5s2.6-.6 9.6-1.7c6.3-1.1 9.7 1.9 10.3 2.5l.1.1 9-1.4 2.3 2.9 7.5.3 5.5-9.3 2.9-7h2.9l.6-5.8 2.3-1.7 6.7-8.1 1.3 1.2.1-3.8-18.7-8.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "N5",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576 251.3l1.2-2.6c1.2-4.3 7.5-5.5 7.5-5.5 7.5-7.8-2.6-17.1-2.6-17.1l-2.9-10.4 2.3-1.4-3.5-8.7-3.2-11.6-2.6-2-4.6 1.4-4.9-3.9-.2.6-.3.7s-4.9 4.5-2.9 6.4c0 0 3 0-.5 4.2l-1.7 3.2.5 4.5-1.7 5-4.5 2.7s-4 2.2-3.5 3.5l-6.2.5-4.5 1.2s-3.2-.7-7-.5h-3.5l-3.7 2.2 1 2.7-2 1.2s-2 5.5-.7 8l-2.5 2.7s-1.7 2-3.5 2.2l-3.5 1.2-3 3-.8 2.5a82.2 82.2 0 0 1-8.8 14.9l7 .8 9 3.2 8.4 8.1 3.8-5.5-1.4-3.8s13-4.3 16.8 2l6.1-4.6 21.1-7.5 4.1-3.2 1.9-.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "N6",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M542.7 267.2c-3.8-6.4-16.8-2-16.8-2l1.4 3.8-3.8 5.5-8.4-8.1-9-3.2-7-.8c-.8 1-1.8 2-3.1 3.3-.9.9-5.5 1.6-5.6 3.1l-1 5.7 3.6 4.3 13.6-.9 8.7 3.8 2 6.1.6 9.6 3 12.5 5.7-.6.9 4.9 11.6-.9 2.6 4.9 10.1-1.4 1.7 3.5 10.5-.3.4-2.4 4.9-2.3-.6-2.9c-4.6-4.3-.3-11.6-.3-11.6h2c5.8-2.3 9-17.4 9-17.4l-1.7-4.9 1.2-4.1 2-2.6v-3.5l-5.8-6.4-5.2-7-21.1 7.5-6.1 4.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "N7",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.9 316.7l-10.1 1.4-2.6-4.9-11.6.9-.9-4.9-5.7.6.2.8-.6 2.9 1.2 2.9-.6 10.7-4.6 7.8.1 1.9.3 5h1.4l3.2-4.1 3.5.9 1.2-2 3.2 2.9.9 4.3 2.6.6 5.2 7.5 5.8 7.5 9.6-5.5s2.6 0 3.5-.3c.9-.3 2-8.7 2-8.7l1.4-3.2c2.9-3.8-.3-6.7-.3-6.7l3.5-3.8v-4l-1.2-5.5 1.4-.9.2-1.1-10.3.2-1.9-3.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "N8",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.8 279.9l-3 .7-2.6-4.1-24.7 3-2.8-2.6s-.4 3.4-3.7 6.4c0 0-8.1 2.3-6.2 6.8l1 4.6 2.7-.2 2.9-4.9 4.6 2.9-.6 2.6s6.1-1.4 5.5-.6l.6-.9-3.2-3.5 1.2-2.6 14.5 7.2.6-2.3 2.5.4 3.9-5.6 6.9-.2v-1.5s-.7-2.2.7-2.2c-.1-.1 3.7-.5-.8-3.4z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "N9",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441 294.7l-14.5-7.2-1.2 2.6 3.2 3.5-.6.9-.2.2.2-.2c.6-.9-5.5.6-5.5.6l.6-2.6-4.6-2.9-2.9 4.9-2.7.2 4.4 11.7 1.1.2.4-2.2a18 18 0 0 1 2.3 5.1c.6 4.2.6 6.1 4.2 8.7l2.6-1.5.3.6.1.3 3.3-5.8 3.5.6 1.2-4.3 5.2.9 1.2-9.3 2.9-4.3-1.4-2.3.1-.2-2.5-.4-.7 2.2z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "N10",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489.4 285.7l6.7-4.1.2-3.1-3.1.2-3.6-4.3-.1.5-.6 2-3.7.3c-.9.2 0 .3-2.5 1.2-2.5.9-3 .3-3.4 2.3-.5 2-1.6 4.8-1.6 5.3s-.5 1.1-1.7 1.9c-1.2.8-2.8 2.9-3.3 3.4s-5.1 4.7-5.1 2.6c0-2 3.1-3.9.2-4-3-.2-2.5-3.3-4-1.9-1.6 1.4-1.6 4.8-3.4 2.3-1.9-2.5-5.1-1.6-5.3-2l-.1-1.5-6.9.2-4.1 5.8 1.4 2.3-2.9 4.3-1.2 9.3-5.2-.9-1.2 4.3-3.5-.6-3.3 5.8.9 2.3c-.6 2.1.3 9.9.3 9.9.2 1.2 1.5 2.2 1.1 3.9-1.1 1.1 3.3 5.9 3.3 5.9.6 2.4 2.2 2.7 2.2 2.7.4-.5 1.2-1.1 2.2-1.7l1.5-.9.2-7.5 4.9 2 4.1-4.1 3.5 3.5s-.9 9 3.8 3.8l2.3-3.5 1.4 1.2 2.6-2.3-4.9-1.7.6-6.4-4.3-.3v-3.2l2.9-1.2-.9-4.1 2.9-5.2 2.1-.1 2.2-.1 1.2 2 7.2-4.9 1.7 2.9 4.3-7.2 11.9.9 1.2-8.4-3.5-2 2.3-2.3v-5.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "N13",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M523.8 384.7l-7 .7-1.6 1.9-5.6-1.7.7-4.1-1.2-4.2.4-2.6.4-4.2 2.4-1.3-1.9-6.8 1.9.1-1.9-4.2 3.5-4.6 3.5.7.7-1.2c-.7-3.8-1-7.9-1.3-11.3l-.3-5-3.2 1.3-7.5 2.9-6.4 4.9-1.2-.3-4.9 2.6-2.3 2.9 2 2.6-.9 2.3h-2.3s0 4.1.3 6.1-4.6 2.9-4.6 2.9l-1.7-.9-7-.6-2.3-4.9-5 1v.3c.1 1.4-2.5 2.6-2.5 2.6-2.2 4.7 1 6.5 1 6.5 3.5-1.5 7.5-.5 7.5-.5-3.5-.5-7.2 2.2-7.2 2.2-.7 5 5 9.7 5 9.7.7-.7 5.2.5 5.2.5 3 1.7 6.2-2.2 6.2-2.2 2.2-1.2 5.5-1 5.5-1l-.7 2.2-4.2 2.2c-1.6 1.4-.9 2.7.4 3.6l4.6.3 1.4 3.5 3.6-1.6 5.5 4.8 2.2 3.3.6-2.5 1.2-1.2h1.3l2 1.7 5.6-1.6 2.5 3.9 7.1-1.7 1.6-2 .6-2.5 1-4.4-2.7-1.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "N14",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M509.6 374.7l-.4 2.6 1.2 4.2-.7 4.1 5.6 1.7 1.6-1.9 7-.7 2.6 1.2-1 4.4 6.2 2.5v.7l4.5 1.3 1.7-1.7 4.3.5c6.7-6.1 1.1-14.6 1.1-14.6l.1-3.8-14.7 3.2-2.3-6.7-2.3 1.7.1-3.9-3.5-3.2-4.7 2.7 1.7 3.5-2.2 2.2-2.9-4.6-.2-.8-2.4 1.3-.4 4.1z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "N15",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543.7 419.6l-2.5-4.2 1.4-3.5.2-.1-2.4-2.9-2.9-.6-1.4-3.8c4.9-1.2 5.2-10.1 5.2-10.1l.9-.8-4.3-.5-1.7 1.7-4.5-1.3v-.7l-6.2-2.5-.6 2.5-1.6 2-7.1 1.7-2.5-3.9-5.6 1.6-2-1.7h-1.3l-1.2 1.2-.6 2.5-2.2-3.3-5.5-4.8-3.6 1.6-1.4-3.5-4.6-.3 1.5.9c1.6.8 3.4 1.2 3.4 1.2-3.7 1-7-1-7-1l-2 1c-1.2.5-5-.7-5-.7-3.2 4-1.5 9.2-1.5 9.2l1.5 3-1.2 1.5c-1.5 5 5 15.4 5 15.4l10.5-4c-.2 3.2 4 .7 4 .7.7-1.7 4.2-2.2 4.2-2.2l-1.7 2.2c-1.2 2.5 2.7.2 2.7.2.2 1-3.5 3.5-3.5 3.5-5-.2-5 3.7-5 3.7-1.7 0-4 1.7-4 1.7-2.7-1-6 3.2-6 3.2-2.7 2.2-5 11.2-5 11.2 1 1.7-.8 6-.8 6-2 5.2.8 4.2.8 4.2 2-2.2 7 1.5 7 1.5 4.5 3.5 6.5.7 6.5.7 1.5-2 5.2-1.7 5.2-1.7 4.2-.5 1-5.2 1-5.2-1-6.7 4.7-5.2 4.7-5.2-5.2 1.5-2.5 5.5-2.5 5.5 1 2.5.2 4.5.2 4.5l-3.5 6.5c-.7 2.2-2.2 2.8-3.3 2.8l1.1 1.8 2.8.6-.1-1.2 27.1 2c2.1-1.6 4.1-4 3.3-7.3l3.7-3.7s3.3-3.5 3.1-4.1c-.2-.6.6-3.7.6-3.7l2.7 1.2 1.7-1.5s.6-5.8 3.3-5.8l.2-2.7 3.9-8.5-1.7-1.7.1-2z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "N16",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M538 352.1l-5.2-7.5-2.6-.6-.9-4.3-3.2-2.9-1.2 2-3.5-.9-3.2 4.1h-1.4c.2 3.3.6 7.4 1.3 11.2l2 1.7h4.3c.4 0 .7.7.7.7l2.9-.6.4 3-1.6 1.2 3 1.3 2.8-1.2 10.9 2.5.1-2.2-5.6-7.5z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "N17",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.8 359.3l-2.8 1.2-3-1.3 1.6-1.2-.4-3-2.9.6s-.3-.7-.7-.7h-1.4l-1.8 2.2 2.3 3-1.3 2.3-1.2 1-.5 3.1 3.4 3.1-.1 3.9 2.3-1.7 2.3 6.7 14.7-3.2.4-13.4-10.9-2.6z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "N18",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.4 362.4l1.3-2.3-2.3-3 1.8-2.2h-2.9l-2-1.7v.1l-.7 1.2-3.5-.7-3.5 4.6 1.9 4.2-1.9-.1 2.2 7.7 2.9 4.6 2.2-2.2-1.9-3.6 4.6-2.6h.1l.5-3.1 1.2-.9z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "N20",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M582.1 382.1l.1-2.3-.6-1-2.6 1.2-3.2-4.8 2.5-2.6.7-3-5.5-7.2-1.7 1-.4-2.8-25.5-1.9-.1-.2-1.9 1.1-.5 15.6-.1 3.8s6.1 9.3-2 15.4c0 0-.3 9-5.2 10.1l1.4 3.8 2.9.6 2.4 2.9 20.7-8.2-.2-5.6 1.7-.2.6-1.7-1-2.5.4-1 1.4.6 1.9-3.1 1.2-3.7 1.9.2.8-1.9-.8-4.1 1.7-1.9 3.9 3.5-.4 2.1 2.9.4 6.4-1.4V382l-2.3.5-1.5-.4z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "N23",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M645.1 415.7l-2.2-3.5 3.6-2.5-8.7-7.4-.3-5.8-2.8 2.6-1.9-2.3-2.3.9-12.8-5.7-.8 3.2-3.5 2.2-1.7 4.9 1.7 3.9v1.3l-.7 1.3-2.6-.4-.1 5.8-2.8 2.2-.1 2.7 4.9 3.4s2.3-1.2 2.8-1.2c.4 0 2.2 3 2.2 3l1.9-1.4 2.6 1.7-1.9 2.8-1.9 6.1 2.1 1.4.8-1.7 1.9-.3 2-3.6 1.4-4.3s2.2-3.2 2.9-3.9c.7-.7 4.8-.1 4.8-.1l.9 1.6 1 .3 5.4-6.6 4.2-.6z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "N34",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616 386.7l-.2-3.7-9.5-7-8.5 1.2-2.1 3.9-9.8 2.1-6.4 1.4-1.7-.2-.8 1.4 2.5.6 1.6.4-.4 2-2 .6-1 2.3 2 2.5-1.2 1.6-1.4-1.4-4.1 4.9 4.3.7 5.2 3.5-.3 2.3 1.7 5.9-5.5 3.8c-.7.4-.7 2.5-.6 2.9.1.4 1.4 1.4 1.7 2.6.3 1.2-1.6 1.4-1.6 1.4l-3.3 4.2-6.4 5.4s-1.9 2.6-2.5 5.5c-.6 2.9 7.7 5.5 8.3 5.9.6.4 3.8.1 4.6.4.9.3.4 2.5.4 4.3 0 .8-.7 1.3-1.6 1.6l.1.3 21.5.4.1-.2 1.9-8.5 4.3-3.8.6-2.6-1.9-1.6.9-2.9.3-4.2-1.6-2.3.6-2.2 1.6-.6 1.2-1.9v-.6l.1-2.7 2.8-2.2.1-5.8 2.6.4.7-1.3v-1.3l-1.7-3.9 1.7-4.9 3.5-2.2 1.4-6.1.2-.2-2.4-2.1z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "N35",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M579.2 448.3c0-1.9.4-4.1-.4-4.3-.9-.3-4.1 0-4.6-.4-.6-.4-8.8-3-8.3-5.9.6-2.9 2.5-5.5 2.5-5.5l6.4-5.4 3.3-4.2s1.9-.3 1.6-1.4c-.3-1.2-1.6-2.2-1.7-2.6-.1-.4-.1-2.5.6-2.9l5.5-3.8-1.7-5.9.3-2.3-5.2-3.5-4.3-.7 4.1-4.9 1.4 1.4 1.2-1.6-2-2.5 1-2.3 2-.6.4-2-1.6-.4-2.5-.6.8-1.4-1.2-.2.4-2.1-3.9-3.5-1.7 1.9.8 4.1-.8 1.9-1.9-.2-1.2 3.7-1.9 3.1-1.4-.6-.4 1 1 2.5-.6 1.7-1.7.2.2 5.6-20.7 8.2-.2.1-1.4 3.5 2.5 4.2-.2 2.1 1.7 1.7-3.9 8.5-.2 2.7c-2.7 0-3.3 5.8-3.3 5.8l-1.7 1.5-2.7-1.2s-.8 3.1-.6 3.7c.2.6-3.1 4.1-3.1 4.1l-3.7 3.7c.8 3.3-1.2 5.7-3.3 7.3l.7.1 13.9-4.6 22.3-4.8 3.2-.7 9-2.6s4.9 1.4 5.7 3c.8-.4 1.5-.9 1.5-1.7z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "N36",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.5 455.1l-.3-1.9 1.6-3.1-22.3 4.8-13.9 4.6-.7-.1-27.1-2 .1 1.2-2.8-.6-1.1-1.8c-.7.1-1.2-.1-1.2-.1-1 0-1.8.7-2.4 1.8-2.3 4.6-.9 16.1-.9 16.1-.4.9-.5 1.8-.6 2.8l-.4 3.1-.4 2.2c3.2-1.3 3.6-7.4 3.6-7.4l1.4.1 2.8 1.3 2.2-.1-.4 2.3-3.6 4.3 1.6.6.3 3.5-1.7.4v1.2l17.8-.9 1.2 3 2.6-.3.6-2.3 3.9-.1-4.1 19 4.8 2.9 11.7 2.6-.4 2.2 9.7 8.8-.3 2.5 2.6 1.6 5.9-1.2-.7-14.6-.4-3.6-3.9-3.2v-1.2l-.3-31.7 4.5-1.7 2.8 3.2 2.5-3.9 3.5 1 2.6-3.9-1.4-3 1.6-.1-.6-8.3z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "N38",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.2 549.9l1.8-3.9-.6-1.6.5-.4-2.2-1.4.8-2.5-6.6-5.2-2.9 3-3.8 6.4 3.3 2.3-1.3 2-6-4.7-1.4 3.3-1.8-.9-1.2 1.5-4.8.8-2.4-1.4-1.3 4.5 2.6 2.6-1.3 2-.8 5.1 2.9.9v-1.6l4.7-.9 3.6 2.5 1.6 3.3 6.2-.3 3.1 3.3 1.8-2.9-.2-6.2 1.4-3-1-1.1 2.3-4 2.3 1.9 1-1.5-.8-.7z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "N39",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M559.5 504.5l.9-3 5.9-1.9 1.6 1.3 2.3-1.4 1.9 1.3 11.4.3.3-3.2.7-.4.9-10.8.3-6.2 3.8-9.6 4.1-5.9-1-1.7 1.9-1.4 4.8-11.2-21.5-.4c-.3-1.7-5.8-3.3-5.8-3.3l-9 2.6-3.2.7-1.6 3.1.3 1.9.3 8.3-1.6.1 1.4 3-2.6 3.9-3.5-1-2.5 3.9-2.8-3.2-4.5 1.7.3 29.7 11.3 1 5.2 1.8z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "N42",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M652.9 508.7l-2.9 1.4-3.2-2.3-3 1.6-4.4 8 4.7 6.1 4.8 3.3 1.2 2.9.5 3.3c3.3-.8 7.4-1.8 8-1.7-.2-.4-.4-2.6-.4-2.6l1.6-1.4-.9-8 1.6-2.9 8.8-1.2v-1.7h.3l-.3-1.9-16.4-2.9z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "N33",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M606.8 466.2l-1.6-.4-1.6-1.7-3.3 3-3-2.3.7-1.7-5 1.1.5.8-4.1 5.9-3.8 9.6-.3 6.2-1 11.7 10.4.1v7.2l6.3 3.7.2-2.2 3-.6 4.9 1.2.1-3.9-5.5-22.5 3.9-.1.7-.7v-4.5l3.6 2 2 .2-1.3-4.8c0-.4-3-4.3-3-4.3l-.3-4.9-1.3-1.3-1.2 3.2z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "N32",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M615 441h-1.9l-1.6 7.2-1.9 2.9.1 2.9-.6 2.6-.1 4.8-.7 1.5 1.3 1.3v-.5l5.1 2.4 1.3-7.7s-3.6-.9-3-3.3c.6-2.5 3.9-1.2 3.9-1.2l4-10.9-4.3-.1-1.6-1.9z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "N41",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M650 529.7l-1.2-2.9-4.8-3.3-4.7-6.1-.1-.2-3-3.9 1.2-4.5-2.5 1-1.2-1.2-1.3 1.3.7 1.7-.6 4.1H629l-3.8 1.3-.3-5.6-2-1.6-5.1 2.5-.9 4.5-3.5-.4-.6 2.6-2.3.1-.6 1.3 3.9 1.6-.9 1.3-9.4-1.7-.6 1.7.6 3-3 1.4-1.1 2.2-.1.2 2.5 4.5 5.9.4 4.5.6 1.6 4.3 7.4.9 7.5.9 4.8-.6 2.2.7 5.2-3.2s5.1 1.7 5.1-4.8l4.4-1.1-.4-3z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "N48",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M684.8 572.2l-4.8 1.4-3.3-2.3 1.2-6.8 1.4-2.5-2.2-1.6 1-1.9-.7-2-2.2 1.4-1.6-1.6 1.3-2.8 1.3.1-1.9-4.2-3.6-2.3-2 1-2.2-3-4.6 1.3-7.8-1.3-.6-2.6-2.9-8.8-.1-.9-4.4 1.1c0 6.5-5.1 4.8-5.1 4.8l-5.2 3.2-2.2-.7-4.8.6-7.5-.9 9.4 20.6 2.9-.9 3.6 6.8-1.2 3.8 1.3.4-1.3 2 5.7 2.6-1.3 4.3 1.7.4 1.4-2 1.3 2.6 26.3 24.5 2.9-.6 8.7-3.8-10.7-.9-.3-2.9 2.9-6.1 5.8-4.9-1.7-3.5 8.4-3.5 3.8.9s1.2-7-3.2-8.1l1.3-1.6-1.3-.4-2.9 1.6z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "N49",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M671.3 606.2L645 581.7l-1.3-2.6-1.4 2-1.7-.4 1.3-4.3-5.7-2.6 1.3-2-1.3-.4 1.2-3.8-3.6-6.8-2.9.9-.3-.6-5.1 5.1-8 4.3-.6 2.6-2.5.7-1.2 2.2-7.5 4.3 1.7 1.2-1.1 3.3c1 .7 1.9 1.3 1.7 1.6-.3.6-.4 3.9-.4 3.9l2.9 3.6 2.3-.9 3.2 4.8-.1 3.3-1 1.9 4.5 3.2 5.5-1.6 4.5-3.8 1 3.9-1.4 1v1.9l3.8-1.6 3.5-3.9 1.9 2.9-1.9 2 1.3 2-1.7 3.5 2.9.1.1 2.9 8.4-3.8 10.4-1 5.9-6.4 5.1 2 .7 3.9 1.8-.1-.9-3.8 1-.1z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "N50",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.4 540.9l-7.4-.9-1.6-4.3-4.5-.6-5.9-.4-2.5-4.5.1-.2-23.4 6 .6 2.8-1.7 1-.9-1-1.2 2-23.9 4.6-.1-1.9-7.9-5.9-7.1 6.5-.5.5.6 1.6-1.8 3.8 3.9 2.7-.9 3-2 2.3 1.3 7-3.6 9.7s-1.2 1.9 2.9 3.6l.5.3c3.6 2.2 4.1 9.9 4.1 9.9l2.9-.6 1 2.5h3.5l1.6 2.3 2 6.2-3.3.1s-2.5 1-3 2.8c-.3 1 .8 1.5 1.7 1.7l1.2-1.4c13.7-4.5 16 7 16 7 .2 2.9-3.1 8.2-3.1 8.2-2 7.1 5.1 6.5 5.1 6.5s2.2-1.4 3-.3c.8 1.1 3.9 2.9 3.9 2.9l2.6.5s3.3-1.2 4.5-2c1-.6 2 .5 2.2.9l.9.3s.3 5.4 4.2 5.9c0 0 1.8-.3 2.9-1.2.8-.7 1.3-1.8.6-3.4l-1.9-1.2s-3.9-4.8.9-3.9c0 0 4.6 5.6 5.4-2.3 0 0 4.3-.6 3.2-2.5-1.2-1.9-2.8-5.1-1-5.9 1.7-.9 3.2.9 3.3 1.9.1 1 3.8 2.3 3.8.9s1.7-3.5 1.7-3.5 2.6-2.5.9-3.2c-1.7-.7-3.3-.3-4.3-1.2-1-.9-2.6-2.2-2.8-3.6l-5.9-3.3 1.7-4.2 2.5 1.7 1.3-1.6 3 .9.7-1s5.4-5.1 1-11.9l1.3-.3 2.6 1.6 1.1-3.3-1.7-1.2 7.5-4.3 1.2-2.2 2.5-.7.6-2.6 8-4.3 5.1-5.1-9.2-20.2z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "N51",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546.1 598.9l3.3-.1-2-6.2-1.6-2.3h-3.5l-1-2.5-2.9.6s-.5-7.7-4.1-9.9l-.5-.3c-4.1-1.7-2.9-3.6-2.9-3.6l3.6-9.7-1.3-7 2-2.3.9-3-3.9-2.7-.6 1.2.9.7-1 1.4-2.3-1.9-2.3 4.1 1 1-1.4 3 .3 6.2-1.9 2.9-3-3.3-6.2.3-1.6-3.3-3.6-2.5-4.6.9v1.6l-2.9-.9.7-5.1 1.3-2-2.6-2.6 1.3-4.5 2.5 1.4 4.8-.9 1.2-1.4 1.9.9 1.3-3.3 6.1 4.8 1.3-2-3.3-2.3 3.8-6.4-5.9-4.6 1.4-2-5.5-3.3-2.8-8-.9-1.2-.9 2-3.2-.6s-1.3.4-1.9-1.3c-.6-1.7 1.6-4.1 1.6-4.1l-.3-3.6-5.4 2.5.5 3.3c2.4 3.2 1.9 7 1.9 7l-1.4 3.9s-1.3 0-.7 5.2c.2 2.1-.7 4-1.9 5.5-.4 1.1-1 2.5-1.9 3.3l-2 .8.2 2.7 1.7.4-.9 2.8 1.6 2.8-4.9.6s1.4 2.6 1.4 3c0 .4-2.3.3-2.3.3l1.6 5.5.1 2.7c.9-.2 3-.6 4.8.7 0 0 6.2-1.7 14.7 4.2 0 0 7.7 6.7 7.7 10.5 0 0 2.9 2.5 5.9 4 3 1.5 10.3 12.6 4.3 23.6-2.2 9.5 4.7 5.5 4.7 5.5 2.2-.4 4.8-2.6 7.6-5.5l2.9-3.2c-1-.2-2.1-.7-1.7-1.7.3-1.7 2.7-2.7 2.7-2.7z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "N52",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M463.8 534.2l2.3.5 1.1 2.9 1.6.3h1.6l1.4.2.9 1.9 1.1 4.8.5 3.3.2 2.3.5.8.2 2.5c0 .5.6 2.5.8 3.3.2.8-3.7.8-3.7.8s-2.6-3.7-2.6-5.4c0-1.7 0-1.9-1.9-3s-2.8-.9-2.8-2.3 1.1-2 .6-2.9c-.5-.9-1.7-1.6-1.6-2.5.2-.9 1.6-2 1.6-2s-2-1.4-2-1.9l-.2-2.5.4-1.1zM499.7 533.1c-.6-5.2.7-5.2.7-5.2l1.4-3.9s.5-3.8-1.9-7v.2l-3-1.6-4.8 2.2-.6 1.9-4.5-.9s.6 3 .7 5.8c.1 2.8-5.6 3.3-5.6 3.3l-2.8-3.5 2.6-3.2-2.5.7h-3s-.4-.9-.4-2.9-2-.7-2-.7l-2.3-1.5-.2.4c-3.2 2.7-2.5 5.3-2.5 5.3l3.2-.5c2.2-2.5 3.7 4.2 3.7 4.2 2.2-1.2 2.5 6.5 2.5 6.5 2.7.2-.7 4.6-.7 6.4 0 1.7 4.7 2 4.7 2-1.5-3.5.7-5 .7-5-.7 1.5 1.2 4.7 1.2 4.7 1.2 0 2.5 1.7 2.5 1.7 4.2 2.5 11.2-6 11.2-6l-.6 1.9a6 6 0 0 0 2.3-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.7 555.3s2.3.1 2.3-.3-1.4-3-1.4-3l4.9-.6-1.6-2.8.9-2.8-1.7-.4-.2-2.7-4.2 1.7-.4 1.8c-2.3 1.3-4.7-1.2-4.7-1.2-2.7-4.2-4.5-2.2-4.5-2.2-.7 4 2.5 5.7 2.5 5.7 6.2 3.7 2.5 4.3 2.5 4.3-5 3 1.7 9.9 4 13.9 0 0 1.6-.2 2.5-1.2.4-.5.7-1.1.5-2l.4-.1-.1-2.7-1.7-5.4z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "N53",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.1 652.7l-.6-9.6h1.9l2.5-13.8 7.8-.1-.1-2.5-2.6-.6-.1-2.8 8.7-.1a5 5 0 0 1-1.3-1.9c-1.2-3.9.3-6.7.3-6.7s1.7-12.1-1.9-11.2c-3.6.9-7.3 4-7.8 4.8-.5.8-6.2 7.5-9.3 7.8-3.1.3-9.3.8-10.9-.2-1.6-.9-5.3-5-9-3.7-3.7 1.2-6.5 7.9-6.5 8.4s.9 34.2 1.7 36.1c.8 1.9 8.1 14.8 21.8 9 0 0 2.6-2.2 3-5.3.2-2.4 2.2-4.4 4-5.1l-.2-2.7-1.4.2z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "N54",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M625.5 646.3l-19.7-2.9-9.3-5.2-8.5-7.6c-1.1 1-2.9 1.3-2.9 1.3-3.9-.6-4.2-5.9-4.2-5.9l-.9-.3.1.1-3.6.3-.9 1.6-4.7.5s-3.6-2.6-5.1-2.3c-1.3.3-5.8-.2-8.2-2.4l-8.7.1.1 2.8 2.6.6.1 2.5-7.8.1-2.5 13.8h-1.9l.6 9.6 1.3-.1.2 2.7 1.3-.3c1.9 0 2.2.9 4.8 1.4 2.6.5 4-.2 7.8-.8 3.7-.6 8.2-.5 8.2-.5s4.7.5 7.9-1.2a20 20 0 0 1 7-2.5c.8 0 2.9-.2 4 0l.6.3s1.7 2 .3 4.7c-1.4 2.6-2.3 5.4-1.1 6.2 1.2.8 13.5 2.2 11.3 7.6 0 0-1.4 2.3-2.5 2.5-1.1.2-4.4.6-4.5 3.4-.2 2.8 1.7 6.2 3.3 6.2 1.6 0 4.4-.5 4.5-2.3.2-1.9 1.2-6.1 3.1-7 1.9-.9 2.2 0 2.2 0l5.4-1.7c.8-.3 3.3-.3 2.8 2.2s-1.1 4.2-.9 4.7c.2.5 3 .3 4.2-.2 1.2-.5 3.9-3.6 3.9-3.6l2.5.5s-2.2 1.2-2.2 3.4l.2 1.6 6-9.7 1.5-2.6 7.3-19.2-5-2.4z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "N56",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M671.3 611.4l-.3-1.1-1.8.1-.7-3.9-5.1-2-5.9 6.4-10.4 1-8.4 3.8-.1-2.9-2.9-.1 1.7-3.5-1.3-2 1.9-2-1.9-2.9-3.5 3.9-3.8 1.6v-1.9l1.4-1-1-3.9-4.5 3.8-5.5 1.6-4.5-3.2 1-1.9.1-3.3-3.2-4.8-2.3.9-.2-.3-.5 2 .1 1.3-1 2.3s3.5 1.7 3.8 3c.3 1.3-4.9 1.9-4.9 1.9l4.6 7-4.9 4.9-1.6-.9-2.8 2.6-1.1-2.9c-1 .2-3.1-.7-3.2-1.5-.1-1-1.6-2.8-3.3-1.9-1.7.9-.1 4.1 1 5.9 1.2 1.9-3.2 2.5-3.2 2.5-.7 8-5.4 2.3-5.4 2.3-4.8-.9-.9 3.9-.9 3.9l1.9 1.2c.7 1.6.2 2.7-.6 3.4l8.5 7.6 9.3 5.2 19.7 2.9 4.9 2-7.2 19.1-1.4 2.6-6 9.7c.3 1.5.9 2.6.9 3v2.9s-.5 2.6 1.1 1.2c1.6-1.4 3.4-2.3 4.7-3.7 1.2-1.4 2.8-5 3.6-4.5.8.5 0 3.3 0 3.3l2.9 4.2s2 4.2-.8 1.9c-2.8-2.3-5.6-3.6-5.6-2.5s-.6 1.1-.6 4.3c0 3.3-1.7 5.6 0 4.7 1.7-.9 2.8-2.6 4-2.6s2.5 2.2 3.7 1.2c1.2-.9 1.1-2.9 2-2.8.9.2 3.6 3.3 3.9 2.2.3-1.1.2-3.4.6-3.7.5-.3 3.1-4.8 3.1-4.8l.6 3.7 2 1.6-2.3 2.3 5.4 2.6-1.2-2.9 1.7-1.6 2.6 6.2.5-7.8 1.7 6.4 4.5-.5-2.6 3.7h-2.5l2.3 2.5 3.3-2.5 3 .5-.3-3.7 2.8 3.1 2.6 1.7-.5 1.9 3.9-2.8 4.7-1.6.3.1 1.2-1.9-1.8-83.8z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "N57",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M733 562.1l.9-4.1-1.4-3.3.9-1.2-.7-4.1-.8 1.1-23.8 11h-4.3l-1.7 2.3-11.3 5.5-2.9 3.5c4.3 1.2 3.2 8.1 3.2 8.1l-3.8-.9-8.4 3.5 1.7 3.5-5.8 4.9-2.9 6.1.3 2.9 10.7.9-8.7 3.8-2.9.6-1.1.2.9 3.8.3 1.1.2 7.3c1.3-1.5 3.6-3.7 4.6-1.9l2.8-2.9 5.4 9.1 4.6-1.3 1.2.9 1-2.2 2.2-1.7 3.2 3.2.7-1.2-1.2-3.9-.7-2.1-2.9.3-1.9-3.5.3-2.8 3.2-.1.1-3.8 8.4-7.1.3.7 3.2-1.6-1.7-1.4-12.7 2.8-1.6-4.2.9-8.5 6.4.9.7-4.8 1.9-1.4s6.1 2.2 7.5-2.9l3 .1s5.1-2.5 10.1-1.4l2.3 1.4 5.2-2.8 3-2.2-1-2.2 3.6-5.1-.7-2.9z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "N58",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M717.1 668.7s7.2 2 7-5.8l-2.3-.9-1.4-4.3 2.9.3v-5.5l5.2-.9 1.2 1.4 1.7-.9-.9-3.5.6-12.2-5.5-.3s-5.2 5.8-4.1-.9l-9-2-.6-2.3 1.4-1.4-1.2-4.6-2.3 1.7-1.7-1.4.9-3.2-2-6.4s-4.5-5.1-7 .3l-1.3-1.2-2.5 1.9h-.4l1.2 3.9-.7 1.2-3.2-3.2-2.2 1.7-1 2.2-1.2-.9-4.6 1.3-5.4-9.1-2.8 2.9c-1-1.8-3.3.4-4.6 1.9l1.9 76.5-1.2 1.9 2.2 1-1.4 4.8.5 1.9s-1.4 4.7.6 5.7c2 1.1 2.8.8 3.7 1.1.9.3 1.9 1.1 4.2.8 2.3-.3 2-.8 2.5-1.1l3.7-1.6s1.1 1.9 1.7 1.6c.6-.3 4.2-3.3 4.2-3.3s1.9-2.6 3.1-2.2c1.2.5 2.8.3 2.8.3s3-4 3.1-4.5c.2-.5-.9-2.8-.9-2.8l-2-9.5-2.9-2.5s.6-2 .5-2.6c-.2-.6-.9-3.1-.9-3.6s.6-2.8.6-2.8l2.5-1.6s4-2 6.5-2.5c1.3-.3 2.7 0 3.8.5l2.4-4.1 4.6-1.2z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "N59",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M775.5 673.3c-.4-.5.7-1.5 1-1.7 3.4-1.9 2.1-5.1-.5-7.6-1-1 .6-2.3 1.7-3.2 1.6-1.4-1.4-1.6.7-4.1 1.3-1.5.9-8.6-1.7-8.5-4 .2-5.5-4.7-5.5-4.7 1.2-1.5-.3-2-.3-2-2-2 .3-3.2.3-3.2 1.5-1-.3-4-.3-4-.7-3 0-2.7 0-2.7s-.3-1.7.5-4c.7-2.2.3-6.5-.7-7.5s1-3.5 1-3.5l-2-.7c-2.2-1.3-2-3.3-2-3.3-.1-.6-.4-1.5-1.5-2.3 2.8-2.3 2.7-3.7 2-7.7 2-.1 2.7-2 3.5-3.2 2.1-3.2 3.1-9.7-.4-11.6-1-.5-2.7.2-3.5-.4-1.4-1.1-.8-3.5-1.8-5-1.4-1.9-4-.8-5.4-2.8-1.4-1.9-3.6-.1-3.6-.1-1.2 3-3.2 1.2-3.2 1.2 0-2-1.7-3.2-1.7-3.2l-.5-2c-.2-2.5-1.7-5.5-1.7-5.5l-2-1.7c1.5-2.2 1-4.2 1-5.7s.5-2.5.5-2.5c1.5-.5 3.2-3.2 3.2-3.2 1.5-2.7-3.5-2.5-3.5-2.5l-4.2-1.5-1.7.5 1.7-.1-2.5.3-6.7-3.2V549l-2.3-.3-.7 1 .7 4.1-.9 1.2 1.4 3.3-.9 4.1.6 3-3.6 5.1 1 2.2-3 2.2-5.2 2.8-2.3-1.4c-5.1-1-10.1 1.4-10.1 1.4l-3-.1c-1.4 5.1-7.5 2.9-7.5 2.9l-1.9 1.4-.7 4.8-6.4-.9-.9 8.5 1.6 4.2 12.7-2.8 1.7 1.4-3.2 1.6-.3-.7-8.4 7.1-.1 3.8-3.2.1-.3 2.8 1.9 3.5 2.9-.3.7 2.1h.4l2.5-1.9 1.3 1.2c2.5-5.4 7-.3 7-.3l2 6.4-.9 3.2 1.7 1.4 2.3-1.7 1.2 4.6-1.4 1.4.6 2.3 9 2c-1.2 6.7 4.1.9 4.1.9l5.5.3-.6 12.2.9 3.5-1.7.9-1.2-1.4-5.2.9v5.5l-2.9-.3 1.4 4.3 2.3.9c.3 7.8-7 5.8-7 5.8l-4.6 1.4-2.4 4.1 2.1 1.2c.9.8 1.9 2.3 2 3.3.2.9 1.1 2.9 1.1 3.4s1.7.8 2.3.9c.6.2 3.6 3.3 3.6 3.3.7.6 4.5-.5 3.6.3-1.3 1.1.7 1.8 2 2.5 2 1.1 4-2.2 5.9-.3 1.5 1.5-.4.7 0 2.6 1.1 5.6 7.7 7.1 8.7 12 .2 1.2 2.8.3 4.3.3-.9-1.1 1.7-.4.7-1.5 2.9.9 7.6 7.9 10.1 8.8 3.9 1.4 3.7-6.9 6.7-8.1 5-1.9 8.4-4 9.7-9.1.5-2 4.2-3 5.2-5.2.8-1.7 1-4.5 2.6-5.4 2-1.1 3.6-1 5.1-.3 1.6-6.6-7.8-6.1-10.5-10.1z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "N55",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M605.8 615.1l1.6.9 4.9-4.9-4.6-7s5.2-.6 4.9-1.9c-.3-1.3-3.8-3-3.8-3l1-2.3-.1-1.3.5-2-2.7-3.3s.1-3.3.4-3.9c.3-.6-4.3-3.2-4.3-3.2l-1.3.3c4.3 6.8-1 11.9-1 11.9l-.7 1-3-.9-1.3 1.6-2.5-1.7-1.7 4.2 5.9 3.3c.1 1.4 1.7 2.8 2.8 3.6 1 .9 2.6.4 4.3 1.2 1.7.7-.9 3.2-.9 3.2s-1.7 2-1.7 3.5c0 .3-.2.5-.5.6l1.1 2.9 2.7-2.8z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "N11",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M521.2 327.2l.6-10.7-1.2-2.9.6-2.9-3.2-13.3-.6-9.6-2-6.1-8.7-3.8-10.6.7-.2 3.1-6.7 4.1v5.5l-2.3 2.3 3.5 2-1.2 8.4-11.9-.9-4.3 7.2-1.7-2.9-7.2 4.9-1.2-2-2.2.1 2.2 7.4 1.4 1.4-1.2 2.3v4.1l2.9-2.9 2.3-1.4-1.2 5.2 3.2.9s8.7-14.8 8.7-15.6c0-.9 6.7-.9 6.7-.9l1.2 8.1-1.2 3.2h6.7l3.8 9.9 4.3 8.7 8.7-8.4 4.3 2.9 2.9 1.3V335l4.8-7.8z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "N12",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M509.4 332.4l-8.7 8.4-4.3-8.7-3.8-9.9h-6.7l1.2-3.2-1.2-8.1s-6.7 0-6.7.9-8.7 15.6-8.7 15.6l-3.2-.9 1.2-5.2-2.3 1.4-2.9 2.9v-4.1l1.2-2.3-1.4-1.4-2.2-7.4-2.1.1-2.9 5.2.9 4.1-2.9 1.2v3.2l4.3.3-.6 6.4 4.9 1.7-2.6 2.3-1.4-1.2-2.3 3.5c-4.6 5.2-3.8-3.8-3.8-3.8l-3.5-3.5-4.1 4.1-4.9-2-.2 7.5 3.2-1.7c2.8-.2 9 3.9 9 3.9l1.3-.9 2.2 2.1c1.9 6 3.4 3.2 3.4 3.2.9-1.1-2.1-3.6-2.1-3.6l1.3-1.5 2.2 1.1c3.5.6-.4-3-.4-3 2.4-4.7 5.8-1.9 5.8-1.9.2 3.9 2.8 4.1 2.8 4.1-3.2.6-3.2-1.3-3.2-1.3.4-3.9-2.6-2.4-2.6-2.4-3 1.1-.6 2.6-.6 2.6 1.7 3.5-1.1 3-1.1 3-3.9-.7-.7 2.2-.7 2.2-1.9 4.3-5.4-.4-5.4-.4-1.5-3.2-4.3-2.2-4.3-2.2l-2.6 1.9c-3.4 1.9-1.9 5.6-1.9 5.6l.9 3.2c0 3.2 7.5 3.7 7.5 3.7 6.2-.7 5.8-4.1 5.8-4.1l2.1-1.1c5.8-.4 2.1-1.7 2.1-1.7-3.7-2.1-2.6-3.6-2.6-3.6 1.9-3.9 6-.4 6-.4.4 2.2 4.1 2.8 4.1 2.8-1.5 1.3-2.4.9-2.4.9a43 43 0 0 0-4.9-4.5c-2.8 1.1-1.1 2.6-1.1 2.6 5 2.1 3.7 3.2 3.7 3.2.7 2.2-1.5 2.7-1.5 2.7l3 4.2c.6.4.9.8 1 1.2l5-1 2.3 4.9 7 .6 1.7.9s4.9-.9 4.6-2.9c-.3-2-.3-6.1-.3-6.1h2.3l.9-2.3-2-2.6 2.3-2.9 4.9-2.6 1.2.3 6.4-4.9 7.5-2.9 3.2-1.3v-.3l-2.9-1.3-4.4-2.6z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "N37",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.6 525.7l.3-2.5-9.7-8.8.4-2.2-11.7-2.6-4.8-2.9 4.1-19-3.9.1-.6 2.3-2.6.3-1.2-3-17.8.9v-1.2l1.7-.4-.3-3.5-1.6-.6 3.6-4.3.4-2.3-2.2.1-2.8-1.3-1.4-.1s-.5 6.1-3.6 7.4l-1.1 6.9c-.8 4.7-4 2-7.1.8.1 1.1-.4 1.7-1.5 1.5l1.8 8.9-4 10.6-2.3 5.9 2.3 1.5s2-1.3 2 .7.4 2.9.4 2.9h3l2.5-.7-2.6 3.2 2.8 3.5s5.8-.6 5.6-3.3a42 42 0 0 0-.7-5.8l4.5.9.6-1.9 4.8-2.2 3 1.6-.6-3.5 5.4-2.5.3 3.6s-2.2 2.3-1.6 4.1c.6 1.7 1.9 1.3 1.9 1.3l3.2.6.9-2 .9 1.2 2.8 8 5.5 3.3-1.4 2 5.9 4.6 2.9-3 6.7 5.2-.9 2.5 2.3 1.4 7.1-6.5 7.9 5.9-.8-17.2-5.9 1.2-2.8-1.6z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "N40",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M604.7 518.9s-2-6.7-3.6-8.7l.1-.8-6.3-3.7v-7.2l-10.4-.1.1-.9-.7.4-.3 3.2-11.4-.3-1.9-1.3-2.3 1.4-1.6-1.3-5.9 1.9-.9 3-5.1-1.9-11.3-1v3.2l3.9 3.2.4 3.6 1.5 31.8.1 1.9 23.9-4.6 1.2-2 .9 1 1.7-1-.6-2.8 23.4-6 1.1-2.2 3-1.4-.6-3 1.6-4.4z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "N43",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M695.9 493.2l-.9-.2-32.7-.1-3.6-5.8 4.3-3.9-4.1-1.3-11.4 1.2-3.3-.1-.7-2.9-2.3 3-1.7-1.3-1.7-4.8-3.8.4-3.3-7-2.6 1.7s-2.6 3-6.2 2.6l-1.2 1.2.6 2.8-1 2.5-4.9.7-1-3.6-2-.2-3.6-2v4.5l-.7.7-3.9.1 5.5 22.5-.1 3.9-4.9-1.2-3 .6-.2 2.2-.1.8c1.6 2 3.6 8.7 3.6 8.7l-1 2.6 9.4 1.7.9-1.3-3.9-1.6.6-1.3 2.3-.1.6-2.6 3.5.4.9-4.5 5.1-2.5 2 1.6.3 5.6 3.8-1.3h3.6l.6-4.1-.7-1.7 1.3-1.3 1.2 1.2 2.5-1-1.2 4.5 3 3.9.1.2 4.4-8 3-1.6 3.2 2.3 2.9-1.4 16.4 2.9.3 1.9 1.7-.1v.9s7.7 1 8.5-1.4l8.4.9 2.3-2.6-.4-2s3.8 0 4.3-1.3c.6-1.3.7-3 .7-3l-1.9-3 1.9-1.7.3-6.9z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "N47",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M738.7 540.2c-1.2-.7-5-3.5-5-3.5-1.5-2-.3-3.7-.3-3.7v-3.7l1.2-2.7-.7-1.2.3-2-1-1.2-1-4.2-5.5-2.7c-2.5-1.7.2-3 .2-3 3.2-1 2.7-2.2 2.7-2.2-.7-4.7 3-5.7 3-5.7l-2.2-3.7c-1-1-8.7-.5-8.7-.5 0-1.5-5-5-5-5l-2.3 1.3-1.7 1.7c-1.1 1.3-3.1.4-4.5-.5l-1.2 1.5-9-8.1-2.2 2.5v.1l-.7 6.6-1.9 1.7 1.9 3s-.1 1.7-.7 3-4.3 1.3-4.3 1.3l.4 2-2.3 2.6-8.4-.9c-.9 2.5-8.5 1.4-8.5 1.4v-.9l-2 .1v1.7l-8.8 1.2-1.6 2.9.9 8-1.6 1.4s.2 2.1.4 2.6h.1c0 .1-.1 0-.1 0-.6-.1-4.7.9-8 1.7l.1.9 2.9 8.8.6 2.6 7.8 1.3 4.6-1.3 2.2 3 2-1 3.6 2.3 1.9 4.2-1.3-.1-1.3 2.8 1.6 1.6 2.2-1.4.7 2-1 1.9 2.2 1.6-1.4 2.5-1.2 6.8 3.3 2.3 4.8-1.4 3-1.4 1.3.4 1.6-1.9 11.3-5.5 1.7-2.3h4.3l23.8-11 1.4-2 2.3.3-.2-4.3 1.2-.7c2.3-1.9 2.1-3.9 2.1-3.9z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "N46",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M714.9 461c-1.8-2.7-6.6.2-6.9-3.1-.2-2.9-2.2-5.6-1.7-8.6l.1-.6v-.1c-2.9-.6-8-1.2-9.7 2.1l-1.2-1.3-1.3.7.1 3.9-2.5-2.3-1.4.6-.6-5.2-3.8-.1s-8.1-2.9-11.4-1l-8-.4-4.8 2-8 2.8H651l-4.3 4.1-.7 1.6-5.1.9-5.2 2.3-2.6 1.4-.4 1.5-.5 1.9-1.9 3.2-1.4.3 1.7 3 3.3 7 3.8-.4 1.7 4.8 1.7 1.3 2.3-3 .7 2.9 3.3.1 11.4-1.2 4.1 1.3-4.3 3.9 3.6 5.8 32.7.1.9.2v-.1l2.2-2.5 9 8.1 1.2-1.5-1.3-.9c-.5-2.2-.6-4.1-1.2-6.2-.6-2.1-1.3-3.4-3.2-4-.2-.1-.8.1-1.4.3l-.8.2c-.6-.9-.1-1.4.2-2.4 1.1-4.3 3.4-3.3 5.8-4.7 2.4-1.4 1.8-5.2 1.8-5.2 1.7-1.5 2.2-3.5 2.2-3.5l-2.5-2.2c.3-1.5 5.7-.2 5.7-.2l3.2-2.5c.9-.9-1.8-5.1-1.8-5.1z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "N45",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M705.1 446.5s-1.4-1.6-2.6-2c-1.2-.4-6.2-.7-6.2-.7l-1.4-3.5-3.2-1.6-2.6-2.3-4.1.1-1 1.7-7.5-4.1s-3.3 2-4.6-.3l1.6-2-4.8-1.9s.6-1.3-.1-1.7c-.7-.4-2.5.6-2.5.6l-5.1 7-8 6.2-3.6-1.2-4.2 3.9s-1.5-2.4-3.7-3.5a4.3 4.3 0 0 0-4.1 0l-1.3.7.8 1.5-1.7 1.4-.3 1.7-1.9.3-.9 4.3 1.4.9-.3 1.3-1.7-.6-3.6.9 1.9 2.5-1.6 4.2.7 1.9 1.9-.6 1.8.3.4-1.5 2.6-1.4 5.2-2.3 5.1-.9.7-1.6 4.3-4.1h2.9l8-2.8 4.8-2 8 .4c3.3-1.9 11.4 1 11.4 1l3.8.1.6 5.2 1.4-.6 2.5 2.3-.1-3.9 1.3-.7 1.2 1.3c1.7-3.4 6.9-2.8 9.7-2.1l.1-.3.2-1.3-1.6-.2z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "N44",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M636.1 442l-2.9 1.6-3.3 1.2-3.9 2.7v2.9l-2.2 2-2.9 10.1s-3.8 3.3-4.2 6.1l-2.5.4.5-2.9-5.1-2.4.3 5.4s3 3.9 3 4.3l1.3 4.8 1 3.6 4.9-.7 1-2.5-.6-2.8 1.2-1.2c3.6.4 6.2-2.6 6.2-2.6l2.6-1.7-1.7-3 1.4-.3 1.9-3.2.5-1.9-1.8-.3-1.9.6-.7-1.9 1.6-4.2-1.9-2.5 3.6-.9 1.7.6.3-1.3-1.4-.9.9-4.3 1.9-.3.3-1.7 1.7-1.4-.8-1.4z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "N31",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.6 427.4l1.9-2.8-2.6-1.7-1.9 1.4s-1.7-3-2.2-3c-.4 0-2.8 1.2-2.8 1.2l-4.9-3.4v.6l-1.2 1.9-1.6.6-.6 2.2 1.6 2.3-.3 4.2-.9 2.9 1.9 1.6-.6 2.6-4.3 3.8-1.9 8.5-.1.2-4.8 11.2-1.9 1.4.6.9 5-1.1-.7 1.7 3 2.3 3.3-3 1.6 1.7 1.6.4 1.5-3.3.7-1.5.1-4.8.6-2.6-.1-2.9 1.9-2.9 1.6-7.2h-.6l1.9-6.4 2 2.3s1.4 2 1.6 1.6l1.8-3.7-2.1-1.4 1.9-5.8z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "N27",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 623.6 437.2 L 621.1 440 L 621.1 442.2 L 620.7 443.2 L 616.7 454.1 C 616.7 454.1 613.4 452.8 612.8 455.3 C 612.2 457.8 615.8 458.6 615.8 458.6 L 614.5 466.3 L 614 469.2 L 616.5 468.8 C 616.9 466 620.7 462.7 620.7 462.7 L 623.6 452.6 L 620.9 450.8 L 621.8 448.3 L 623 448.4 L 622.6 445.8 L 623.5 445.7 L 623.9 443.2 L 625.5 439.1 L 625.5 439 L 623.6 437.2 L 623.6 437.2 Z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "N26",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 628.5 439.1 L 627 440.5 L 625.4 440.5 L 625.5 439.2 L 623.9 443.3 L 623.5 445.8 L 622.6 445.9 L 623 448.5 L 621.8 448.4 L 620.9 450.9 L 623.6 452.7 L 623.6 452.6 L 625.8 450.6 L 625.8 447.7 L 629.7 445 L 632.4 444.1 C 631.6 442.6 629.8 440.3 628.5 439.1 L 628.5 439.1 Z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "N29",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 626 424.9 L 624.6 429.2 L 624.1 430.1 L 625.5 432.4 L 624.3 434.7 L 623.1 437.9 L 623.7 437.2 L 625.6 438.9 L 625.5 440.3 L 627.1 440.3 L 628.7 438.9 L 631.3 437.3 L 631.7 435.6 L 632.4 432 L 632.4 430.2 C 630.334 428.184 628.551 425.896 627.1 423.4 L 626 424.9 L 626 424.9 Z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "N25",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 637.8 434.1 L 639.4 433.7 L 641.6 431.5 L 642.3 429 L 640.7 430.9 L 642.3 429 L 638.1 430.6 L 632.3 429.2 L 632.3 432.1 L 631.6 435.7 L 631.2 437.4 L 628.6 439 L 628.5 439.1 C 629.8 440.3 631.6 442.6 632.6 443.9 L 633.3 443.7 L 637.5 441.4 C 639 440.6 640.4 440.8 641.6 441.4 L 642 439.5 L 637.7 437.2 L 637.8 434.1 L 637.8 434.1 Z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "N24",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M710.6 425.8c.3-3.2-2.7-5.7-2.7-5.7-.2-2.7-2.5-3.7-2.5-3.7l-3.3-3.1-.2-.2-.1-.6-3 1.1-4.5.7-1.6-3.3-2.8-.6v-4.8l-3-2.9-2 1-2.6-2.2c.4-2-.9-4.3-.9-4.3s-1.6.9-2.9.6c-1.3-.3-3-1.9-3-1.9-1.6-5.9-6.4-4.1-6.4-4.1l-3.2.7c-3-8.1-14.3-7.8-14.3-7.8l-.9-1.7-7.4.3-4.3-1.2-4.2 2-9.6 3.9-2-1.3-2.5-1.2-2.2 3.2-.2.2-.7 2.8 12.8 5.7 2.3-.9 1.9 2.3 2.8-2.6.3 5.8 8.7 7.4-3.6 2.5 2.2 3.5-4.2.4-5.4 6.6 1.2.3 5.9-1-.3 7-.7 2.5-2.2 2.2-1.6.4-.3 3 4.3 2.3-.4 1.9c2.2 1.1 3.7 3.5 3.7 3.5l4.2-3.9 3.6 1.2 7.8-6.2 5.1-7s1.7-1 2.5-.6c.7.4.1 1.7.1 1.7l4.8 1.9-1.6 2c1.3 2.3 4.6.3 4.6.3l7.5 4.1 1-1.7 4.1-.1 2.6 2.3 3.2 1.6 1.4 3.5s5.1.3 6.2.7c1.2.4 2.6 2 2.6 2l1.6.4c.3-4.2-1.7-7.2-1.7-7.2l2.5-1.2c1-1.2 1.4-3.7 2.6-3.9l2.3-.5c-2.3-2.2 1.3-5.7 1.3-5.7l.3-1.2c-1.9 1.1-3-1.2-3-1.2z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "N30",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 624 430.2 L 622.5 432.9 L 620.6 433.2 L 619.8 434.9 L 618 438.6 C 617.9 439 616.4 437 616.4 437 L 614.4 434.7 L 612.5 441.1 L 615 441.1 L 616.6 443.1 L 620.9 443.2 L 621.3 442.2 L 621.3 440 L 623.1 437.9 L 624.3 434.7 L 625.5 432.4 L 624 430.2 L 624 430.2 Z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "N2",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M828.1 175.2c1.1-2.9 0-8.1-3.3-9.1-2-.6-1.1 1.2-3.1 3.1-1.4-3.1-6.5-7.4-8.6-1.1-.5 1.6-3-.9-4.5-1.7-5.7-3.1-6.6 1.2-7.9-2.7-1.1-3.5 2-5.4 3.7-8.6a8 8 0 0 0 .7-1.5c-.5-2.2 1-2.7 1-2.7 1.2-1 .8-3.2.8-3.2-.3-1.5 2-5.5 2-5.5.3-1.5-3.5-2.7-3.5-2.7l-4.5-2.5-1-1.2c0-1.5.5-4.7.5-4.7 1.5-1.7 1-3.2 1-3.2-.8-.7-1-2.5-1-2.5 1-2.2.5-3.2.5-3.2-.8-2.2.2-3.7.2-3.7l1.7-.3 3.2-4.7c1.2-1.5 2.3-1.7 2.3-1.7l3.2-3.2-.5-1.7-.5-3.2-.5-1.7s1.2-2 1.2-2.7c0-.7-1-4.7-1-4.7 1-4.7-.7-4.2-.7-4.2 2-1.5-.2-5.5-.2-5.5l-1.7.5-2.7-2.5-.5-2.5-1.5-1 .5-2.2-1-2-2 .3 1-2.7c.7-1.2-.8-4.2-.8-4.2s.8-2.2.8-4.2-1.2-1.7-1.2-1.7l2.2-3.2-1.2-2.2c-.5-1.2-2.2-.3-3.5.5-1.2.7-3.2-.4-3.2-.4l-2.7-1.5s-1.2-1-1.2-2.2-.7-3.7-.7-3.7c-2.5-.7-1.5-4.2-1.5-4.2l-2.2-1.5-2.7.7-2.5-2.2-1.2-3c-1.7-2.7-3.7.2-3.7.2-2 3.2-4.1 3.6-4.1 3.6-5.5-.5-9.2 3.5-9.2 3.5l-.7 2.7-2.7-1-2.7 2.7-3.2 3.2H751v4l-2.2-1.5-1.5 1.2-2.7-1.7-2 .7-2 1.5c-4-1.2-5.7-.7-5.7-.7l-4.2-2-2 1.5-6.7-1-1 6-1.7 1.2-2.2 6.2-4.7-.3-3 2.2-1 4-2 .7-1.2-.7c-4.5-3-5 1.7-5 1.7-3 2-4-2.5-4-2.5l-2.2-.4c-.8-.1-1.7 2.2-2.8 1.1-1.8-1.8-2.1-1.2-3.5-.2-2.2 1.7-4.2 2.5-4.5 5.7-.5 3.2-1.7 5.2-2.7 7.5-1 2.2-1.8 2.8-.3 4.9 1.2 1.6 1.8 5 2 7 .3 2.5 2.2 3.7-1.9 5-1.2.3-.6 3.3-1.4 3.7-1.4.8-2.8.8-3.5 1.7-1.3 1.7-5.5-.5-5.7 2-.1 1 1.2 3 .7 3.7-1 1.4-2 2.2-3 3.1l5.6 9.5-.6 3.8-2.6-.6-1.4 2 .3 7c-4.9-2.6-20.9.6-20.9.6l-9.8-1.4 4.1 7.8s-2 4.3-6.4 7c-4.3 2.6-8.1-1.7-8.1-1.7l-4.6-6.4-3.2 3.5.3 2.6-4.1 6.1-3.5-2.6-1.7 10.4 3.2-.2 11.6 9.3 3.8 3.2 2.9 4.6 2.3 4.6 7.2 2.3 5.8 1.2 3.2-4.6 4.3-.9.3 7 4.1-1.2 3.5.9 4.3 2.6 2.3-.9-.3-2.9 6.7-3.2 3.8 2-2 2.9-3.5 1.7 3.5 5.8s-4.9 3.2-6.1 7l3.5 2.3s7.2 1.4 1.7 8.7l-2.3 2.9s7.2 2.9 2.6 6.4v3.8l-1.2 1.7v6.7l2.6 3.8 6.7 17.7 4.8 4.2c7.2-6.5 10.5 4.8 10.5 4.8l3.8 1.2 4.1 11.6.9 1.7 2.9-2.9 13 9.9.9 6.4 3.8 9.6 8.6 4.5c1.9-2.3 2-6.1 2-6.1.7.2 1.1-3.9 1.1-4.5.3-2.8-.5-2.4 0-5.2.1-.3 1.4-2.4 1.9-2.6 1.7-.9 4.1-2.5 4.5-3.4 1-2.6-2-2.2-2.7-5-.2-.7 3.1-5.2 3.1-6.5-.1-4.3-1.2-6.1.4-9.7 1.4-3.2 1.1-7.5 3-7.8 3.3-.7 4.4-4.8 5.2-6.4 1.3-2.4-2.5-5.2-1-7.2.9-1.3 2.7-2.9 3.5-4.3 1.1-1.9-.7-3.9-.6-6a4 4 0 0 0 3.8-1.5c-.4 1 2.2 1 .8 2.3h3.8c-.9-4.2 4.8-5.4 7.1-7.4 3.2-2.8.2-7.3 2.2-11.3.1-.3.6-1.1 1.3-1.1 5.5 0 8.9-1.6 9.4-5.4 1.4.6 2.5-1.3 3.7-.6 1.6.9 2.7 2.2 3.5 3 2.5 2.2 4.8-1.8 7 1.1 1.1 1.4 2.7 2.4 3.7 4.1.2.3 1.4.3 2 0 1.8-.6 1.1-2.5 1.8-3.6.9-1.6 1 1 2.6-.1 4.5.8 5.6-1.9 8.2-3.7 1.9-1.3 5.5-1.6 7.2-4 2.4-3.5 1.6-6-.5-9-2.5-3.7 1.8-8.4.3-12.1-.7-1.8-3.4-6-2.1-7.7 1-3.8 2.3-4.4 3.3-6.9z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "N28",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 636.7 423.1 L 634.5 422.5 L 633.6 420.9 C 633.6 420.9 629.5 420.3 628.8 421 L 627 423.3 C 628.1 425.6 630.6 428.4 632.3 430.1 L 632.3 429.1 L 638.1 430.5 L 642.3 428.9 L 642.6 421.9 L 636.7 423.1 L 636.7 423.1 Z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "N22",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M721.4 357.9l-.4 2.8-3.2.4-2.9-3.6-3.2 3.8v3l-2-1.4-.1 2.5-3.5.1.3 2-5.1-1.4-3.2 1.6-2.9-3.2 1-1.3-1-2.6-4.3-1-3-1.4-2.5-.6v3.9l-1 1-2.6-2.2-3 1.4-2.9-1.2-2.2.3-1.9-3.6 1.2-1.2.4-1.4 3-2.6-.6-1.4-7.5 1 .9-2.2-1.4-.4-2.8.9-.9-2.9.3-2.8-.4-1.4-1.9.3-.9 15.4-2 .7-2.6-1.6v3.9l-2.5 3-1.4-2.2-1.9.1-2.6-1.2-8.4.1-1.4.9-6.4-1.3-6.7-.7.9 3.3-1.3 5.6-2.5 1.6-3.3-1.3-1.2 1 .6 3.6-11.6 1.6-.4.5 9.3 6.8.2 3.7 2.6 2.2 2.2-3.2 2.5 1.2 2 1.3 9.6-3.9 4.2-2 4.3 1.2 7.4-.3.9 1.7s11.3-.3 14.3 7.8l3.2-.7s4.8-1.9 6.4 4.1a9 9 0 0 0 3 1.9c1.3.3 2.9-.6 2.9-.6s1.3 2.3.9 4.3l2.6 2.2 2-1 3 2.9v4.8l2.8.6 1.6 3.3 4.5-.7 3-1.1-.4-2.9 2.2-2 .5-3.5c.7-1 2 .2 2 .2-.2.7 1.5 1.5 1.5 1.5 1.5 0 3.2-2.5 3.2-2.5l2 .5c-.5 1 1.2 1.5 2 1.7 1-.5 2.7-4 2.7-4l-.7-5-1.5-3.2-1.7-4.2c.7-.7 7.7-1 7.7-1l-.7-2.7c4.5-6.2 5.7-11.2 5.7-11.2l-4-6.5.8-2.7 2.7-.2c-2-1.7-.3-3.5-.3-3.5h.1l-2.5-2.9-1.8-.6z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "N21",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M738 338.9c-.9-1.7-1.6-2.6-2.8-4.2 1.5-1 1-3.2.5-4-1.6-2.6-6.3-3.2-6.6-6.4-1.1.4-1.7-.1-2.3-.8 1.4-.7 6.4-3.8 6.4-3.8l2.5-.2 2.2-3.5-2.7-2c.3-.2 1.7-.3 1.9-.5l.6-.6-8.6-4.5-3.8-9.6-.9-6.4-13-9.9-2.9 2.9-.9-1.7-4.1-11.6-3.5-1.1s-3.4-11.3-10.5-4.8l1.8 1.6s-3.5 12.5-20.9 8.1c0 0-4.9 13.3-7.8 15.1l-2.9-.3-.9-3.2-12.5 11.9-5.2-.9-5.2-3.2-3.5 2.3-2.9-2.6-6.7 8.1-2.3 1.7-.6 5.8H617l-2.9 7-5.5 9.3-7.5-.3-2.3-2.9-9 1.4-.1-.1-1.3 2.6 1.7 1 2.5-1.9h1.9l1.7 9.3-1.4 3.3.8 3.9 4.1 3.1-.2 4.2c0 1.9-3.5 1.4-3.5 1.4l-.8-2.1-2.5-1.7-3.7-1.2-2.5 7.1-.4 6.6 3.9 5.2 1 4.1-5.2 8.5-.1 5 9.8-2.1 2.1-3.9 8.5-1.2.2.1.4-.5 11.6-1.6-.6-3.6 1.2-1 3.3 1.3 2.5-1.6 1.3-5.6-.9-3.3 6.7.7 6.4 1.3 1.4-.9 8.4-.1 2.6 1.2 1.9-.1 1.4 2.2 2.5-3v-3.9l2.6 1.6 2-.7.9-15.4 1.9-.3.4 1.4-.3 2.8.9 2.9 2.8-.9 1.4.4-.9 2.2 7.5-1 .6 1.4-3 2.6-.4 1.4-1.2 1.2 1.9 3.6 2.2-.3 2.9 1.2 3-1.4 2.6 2.2 1-1v-3.9l2.5.6 3 1.4 4.3 1 1 2.6-1 1.3 2.9 3.2 3.2-1.6 5.1 1.4-.3-2 3.5-.1.1-2.5 2 1.4v-3l3.2-3.8 2.9 3.6 3.2-.4.4-2.8 1.7.6 2.5 2.9c3.6 1 6.3-1.6 10-.4l.1-.9c-.1-1.5-2.2-2.9-2-4.4-.8 0-2 .1-2-.1-1-4.6 4.2-1.9 5.5-4.7.9-1.9 1.1-4.4 1.3-6.5.3-1.9.6-4-.3-5.7z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "N19",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M595.9 343.1l-.8-3.9 1.4-3.3-1.7-9.3h-1.9l-2.5 1.9-1.7-1 1.3-2.6c-.6-.6-4-3.6-10.3-2.5l-9.6 1.7-6.4 3.5v3.7l-3.5 3.8s3.2 2.9.3 6.7l-1.4 3.2s-1.2 8.4-2 8.7c-.9.3-3.5.3-3.5.3l-7.7 4.4.1.2 25.5 1.9.4 2.8 1.7-1 5.5 7.2-.7 3-2.5 2.6 3.2 4.8 2.6-1.3.6 1-.1 2.3 1.6.3 2.3-.5.1-3.6 5.2-8.5-1-4.1-3.9-5.2.4-6.6 2.5-7.1 3.7 1.2 2.5 1.7.8 2.1s3.5.6 3.5-1.4l.2-4.2-4.2-2.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "matrix(1, 0, 0, 1, -16, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 127.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N1\n    "), /*#__PURE__*/React.createElement("text", {
    x: 729.3,
    y: 171.5,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N2\n    "), /*#__PURE__*/React.createElement("text", {
    x: 636.7,
    y: 220.5,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N3\n    "), /*#__PURE__*/React.createElement("text", {
    x: 586,
    y: 299.5,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N4\n    "), /*#__PURE__*/React.createElement("text", {
    x: 539.2,
    y: 248.7,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N5\n    "), /*#__PURE__*/React.createElement("text", {
    x: 544.2,
    y: 293.5,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N6\n    "), /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 332.4,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N7\n    "), /*#__PURE__*/React.createElement("text", {
    x: 431.5,
    y: 288,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N8\n    "), /*#__PURE__*/React.createElement("text", {
    x: 422,
    y: 304.3,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N9\n    "), /*#__PURE__*/React.createElement("text", {
    x: 447,
    y: 303.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N10\n    "), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 307.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N11\n    "), /*#__PURE__*/React.createElement("text", {
    x: 471.3,
    y: 340.1,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N12\n    "), /*#__PURE__*/React.createElement("text", {
    x: 486.7,
    y: 373.3,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N13\n    "), /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 386.8,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N14\n    "), /*#__PURE__*/React.createElement("text", {
    x: 503.6,
    y: 427.4,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N15\n    "), /*#__PURE__*/React.createElement("text", {
    x: 517.9,
    y: 353,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N16\n    "), /*#__PURE__*/React.createElement("text", {
    x: 524.2,
    y: 371,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N17\n    "), /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 362.9,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N18\n    "), /*#__PURE__*/React.createElement("text", {
    x: 563.4,
    y: 348.1,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N19\n    "), /*#__PURE__*/React.createElement("text", {
    x: 548.2,
    y: 383.6,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N20\n    "), /*#__PURE__*/React.createElement("text", {
    x: 657.2,
    y: 326,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N21\n    "), /*#__PURE__*/React.createElement("text", {
    x: 671.8,
    y: 378.5,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N22\n    "), /*#__PURE__*/React.createElement("text", {
    x: 662.7,
    y: 420,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N24\n    "), /*#__PURE__*/React.createElement("text", {
    x: 616.3,
    y: 411.6,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N23\n    "), /*#__PURE__*/React.createElement("text", {
    x: 626.8,
    y: 444,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N25\n    "), /*#__PURE__*/React.createElement("text", {
    x: 622.8,
    y: 425,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N28\n    "), /*#__PURE__*/React.createElement("text", {
    x: 595.8,
    y: 440,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N30\n    "), /*#__PURE__*/React.createElement("text", {
    x: 613.8,
    y: 435,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N29\n    "), /*#__PURE__*/React.createElement("text", {
    x: 585.4,
    y: 403.7,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N34\n    "), /*#__PURE__*/React.createElement("text", {
    x: 590.6,
    y: 452,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N31\n    "), /*#__PURE__*/React.createElement("text", {
    x: 544,
    y: 442.5,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N35\n    "), /*#__PURE__*/React.createElement("text", {
    x: 506.8,
    y: 476.3,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N36\n    "), /*#__PURE__*/React.createElement("text", {
    x: 481.7,
    y: 506.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N37\n    "), /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 557.6,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N38\n    "), /*#__PURE__*/React.createElement("text", {
    x: 559.3,
    y: 482.7,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N39\n    "), /*#__PURE__*/React.createElement("text", {
    x: 565.5,
    y: 517.9,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N40\n    "), /*#__PURE__*/React.createElement("text", {
    x: 642.4,
    y: 520.4,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N42\n    "), /*#__PURE__*/React.createElement("text", {
    x: 585.8,
    y: 488.9,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N33\n    "), /*#__PURE__*/React.createElement("text", {
    x: 659.3,
    y: 443.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N45\n    "), /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 492.3,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N43\n    "), /*#__PURE__*/React.createElement("text", {
    x: 611.8,
    y: 462,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N27\n    "), /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 476.3,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N44\n    "), /*#__PURE__*/React.createElement("text", {
    x: 591.6,
    y: 462.9,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N32\n    "), /*#__PURE__*/React.createElement("text", {
    x: 615.8,
    y: 452,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N26\n    "), /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 475.6,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N46\n    "), /*#__PURE__*/React.createElement("text", {
    x: 616.8,
    y: 529.7,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N41\n    "), /*#__PURE__*/React.createElement("text", {
    x: 700.8,
    y: 532.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N47\n    "), /*#__PURE__*/React.createElement("text", {
    x: 649.7,
    y: 571.3,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N48\n    "), /*#__PURE__*/React.createElement("text", {
    x: 618.2,
    y: 588.6,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N49\n    "), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 574.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N50\n    "), /*#__PURE__*/React.createElement("text", {
    x: 494.7,
    y: 577.9,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N51\n    "), /*#__PURE__*/React.createElement("text", {
    x: 459.5,
    y: 533.9,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N52\n    "), /*#__PURE__*/React.createElement("text", {
    x: 519.2,
    y: 629.8,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N53\n    "), /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 655.2,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N54\n    "), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 654.6,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N56\n    "), /*#__PURE__*/React.createElement("text", {
    x: 701.3,
    y: 571.5,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N57\n    "), /*#__PURE__*/React.createElement("text", {
    x: 691.9,
    y: 654.6,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N58\n    "), /*#__PURE__*/React.createElement("text", {
    x: 746.7,
    y: 656,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N59\n    "), /*#__PURE__*/React.createElement("text", {
    x: 593.3,
    y: 601.8,
    style: {
      whiteSpace: "pre"
    }
  }, "\n      N55\n    ")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDPerak);
export default __webpack_public_path__ + "static/media/d_perak.e6615b2c.svg";
export { ForwardRef as ReactComponent };